import React from 'react';
import PropTypes from 'prop-types';
import './BackButton.css';

import { useTranslation } from 'utils/modifiedTranslation';
import { useHistory } from 'react-router-dom';

import BackIcon from 'assets/icons/back.svg';

export const BackButton = ({ action }) => {
  const history = useHistory();
  const { t } = useTranslation();
  return (
    <div className="back-button middle" onClick={action || (() => history.goBack())}>
      <img alt="" src={BackIcon} />
      {' '}
      {t('trial.back')}
    </div>
  );
};

BackButton.propTypes = {
  action: PropTypes.func,
};
